import i18n from 'i18next'
import { dayAheadBidTableStore } from './store/dayAheadBidTableStore'

export type DayAheadBidTableLeaveIntent = 'date' | 'tab' | 'partition' | 'mode' | 'scenario' | 'route'

export function confirmDayAheadBidTableLeave(intent: DayAheadBidTableLeaveIntent): boolean {
  if (dayAheadBidTableStore.isSavePending) {
    return false
  }

  if (!dayAheadBidTableStore.hasPendingEdits) {
    return true
  }

  const messages: Record<DayAheadBidTableLeaveIntent, string> = {
    date: i18n.t('Discard unsaved bid changes and change the date?'),
    tab: i18n.t('Discard unsaved bid changes and change the tab?'),
    partition: i18n.t('Discard unsaved bid changes and change the partition?'),
    mode: i18n.t('Discard unsaved bid changes and switch editing mode?'),
    scenario: i18n.t('Discard unsaved bid changes and change the scenario?'),
    route: i18n.t('Discard unsaved bid changes and leave Day Ahead Trading?'),
  }

  if (!window.confirm(messages[intent])) {
    return false
  }

  dayAheadBidTableStore.discardPendingEdits?.()
  return true
}
